import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Testimony Hub page.
 * Reserves layout space to prevent CLS.
 *
 * Layout breakdown:
 * - PageHeader with gradient: ~120px
 * - Stats bar: ~80px
 * - Search bar + filters: ~140px
 * - Card grid (6 cards): ~320px
 * - Pagination: ~60px
 */
export function TestimonyPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton variant="gradient" showDescription={true} />}>
      <div className="py-8 space-y-6">
        {/* Stats Bar */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4 space-y-3">
          <div className="flex flex-wrap gap-6">
            <div className="space-y-1">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-7 w-16" />
            </div>
            <div className="space-y-1">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-7 w-16" />
            </div>
            <div className="space-y-1">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-7 w-12" />
            </div>
          </div>
          <Skeleton className="h-2 w-full rounded-full" />
        </div>

        {/* Search and Filters Card */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-6 space-y-4">
          {/* Search Bar */}
          <Skeleton className="h-12 w-full" />

          {/* Filter Controls Row */}
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-9 w-[150px]" />
            <Skeleton className="h-9 w-[180px]" />
            <Skeleton className="h-9 w-[140px]" />
            <Skeleton className="h-9 w-[140px]" />
            <Skeleton className="h-9 w-[140px]" />
            <Skeleton className="h-9 w-[120px]" />
          </div>

          {/* Results Summary Row */}
          <div className="flex items-center justify-between pt-4 border-t border-border">
            <Skeleton className="h-4 w-48" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-20" />
              <Skeleton className="h-8 w-20" />
            </div>
          </div>
        </div>

        {/* Card Grid */}
        <CardGridSkeleton count={6} />

        {/* Pagination */}
        <div className="bg-card border border-border rounded-lg shadow-sm px-6 py-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-20" />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
